import React from 'react';
import Hero from '@/components/sections/Hero';
import AboutSection from '@/components/sections/AboutSection';
import StatsSection from '@/components/sections/StatsSection';
import MissionSection from '@/components/sections/MissionSection';
import ProgramsSection from '@/components/sections/ProgramsSection';
import AdmissionsSection from '@/components/sections/AdmissionsSection';
import StudentApplicationSection from '@/components/sections/StudentApplicationSection';
import ImpactSupportSection from '@/components/sections/ImpactSupportSection';
import SponsorshipHighlightsSection from '@/components/sections/SponsorshipHighlightsSection';
import TestimonialsSection from '@/components/sections/TestimonialsSection';
import ContactSection from '@/components/sections/ContactSection';

const PublicSite = () => {
  return (
    <>
      <Hero />
      <AboutSection />
      <StatsSection />
      <MissionSection />
      <ProgramsSection />
      <AdmissionsSection />
      <StudentApplicationSection />
      <ImpactSupportSection />
      <SponsorshipHighlightsSection />
      <TestimonialsSection />
      <ContactSection />
    </>
  );
};

export default PublicSite;